// The account report returns a balance relative to the account's normal side.
export function balanceSide(balance, accountType) {
  if (Math.abs(Number(balance || 0)) < 0.005) return '';
  return accountType === 'P' ? (balance < 0 ? ' D' : ' C') : (balance < 0 ? ' C' : ' D');
}
